module.exports = __webpack_public_path__ + "static/img/fcmdm.2c6a9a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fcmdm.png
// module id = xFJZ
// module chunks = 4